<div class="vehicles-result">
  <div class="vehicles-header" *ngIf="vehicles().length > 0">
    <span class="vehicles-count">{{
      'VEHICLES_RESULT.COUNT' | translate: { count: vehicles().length }
    }}</span>
  </div>

  <div class="table-wrapper" *ngIf="vehicles().length > 0">
    <app-vehicles-table
      [vehicles]="vehicles()"
      [canEdit]="true"
      [checkboxEnabled]="false"
      [onRemove]="removeVehicle"
    ></app-vehicles-table>
  </div>

  <div *ngIf="vehicles().length === 0" class="empty-state">
    {{ 'VEHICLES_RESULT.EMPTY_STATE' | translate }}
  </div>
</div>
